import { useTranslation } from 'react-i18next';
import { EmptyIcon } from '../..';
import { EmptyLayout, type EmptyLayoutProps } from './empty-layout';

export interface EmptySearchProps extends EmptyLayoutProps {}
export const EmptySearch = memo(function EmptySearch({ children, ...props }: EmptySearchProps) {
  const { t } = useTranslation();
  return (
    <EmptyLayout icon={<EmptyIcon />} {...props}>
      {children || t('filter.noResults')}
    </EmptyLayout>
  );
});
